module.exports = __webpack_public_path__ + "static/media/successLogo.97be09bb.svg";